 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import A527055923605270645_4300H2HTM from '@/components/2527055923605270645_4300h2.htm'
 import A527055923605270645_4300H3HTM from '@/components/2527055923605270645_4300h3.htm'
 import A527055923605270645_4300H4HTM from '@/components/2527055923605270645_4300h4.htm'
 import A527055923605270645_4300H5HTM from '@/components/2527055923605270645_4300h5.htm'
 import A527055923605270645_4300H6HTM from '@/components/2527055923605270645_4300h6.htm'
 import A527055923605270645_4300H7HTM from '@/components/2527055923605270645_4300h7.htm'
 import A527055923605270645_4300H8HTM from '@/components/2527055923605270645_4300h8.htm'
 import A527055923605270645_4300H9HTM from '@/components/2527055923605270645_4300h9.htm'
 import A527055923605270645_4300H10HTM from '@/components/2527055923605270645_4300h10.htm'
 import A527055923605270645_4300H11HTM from '@/components/2527055923605270645_4300h11.htm'
 import A527055923605270645_4300H12HTM from '@/components/2527055923605270645_4300h12.htm'
 import A527055923605270645_4300H13HTM from '@/components/2527055923605270645_4300h13.htm'
 import A527055923605270645_4300H14HTM from '@/components/2527055923605270645_4300h14.htm'
 import A527055923605270645_4300H15HTM from '@/components/2527055923605270645_4300h15.htm'
 import A527055923605270645_4300H16HTM from '@/components/2527055923605270645_4300h16.htm'
 import A527055923605270645_4300H17HTM from '@/components/2527055923605270645_4300h17.htm'
 import A527055923605270645_4300H18HTM from '@/components/2527055923605270645_4300h18.htm'
 import A527055923605270645_4300H19HTM from '@/components/2527055923605270645_4300h19.htm'
 import A527055923605270645_4300H20HTM from '@/components/2527055923605270645_4300h20.htm'
 import A527055923605270645_4300H21HTM from '@/components/2527055923605270645_4300h21.htm'
 import A527055923605270645_4300H22HTM from '@/components/2527055923605270645_4300h22.htm'
 import A527055923605270645_4300H23HTM from '@/components/2527055923605270645_4300h23.htm'
 import A527055923605270645_4300H24HTM from '@/components/2527055923605270645_4300h24.htm'
 import A527055923605270645_4300H25HTM from '@/components/2527055923605270645_4300h25.htm'
 import A527055923605270645_4300H26HTM from '@/components/2527055923605270645_4300h26.htm'
 import A527055923605270645_4300H27HTM from '@/components/2527055923605270645_4300h27.htm'
 import A527055923605270645_4300H28HTM from '@/components/2527055923605270645_4300h28.htm'
 import A527055923605270645_4300H29HTM from '@/components/2527055923605270645_4300h29.htm'
 import A527055923605270645_4300H30HTM from '@/components/2527055923605270645_4300h30.htm'
 import LOVE_2 from '@/components/love_2'
 import COPYRIGHT from '@/components/copyright'
 import AUBA from '@/components/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/2527055923605270645_4300h2.htm",
 			"name" : "2527055923605270645_4300h2.htm",
 			"component" : A527055923605270645_4300H2HTM
 		},
 		{
 			"path" : "/2527055923605270645_4300h3.htm",
 			"name" : "2527055923605270645_4300h3.htm",
 			"component" : A527055923605270645_4300H3HTM
 		},
 		{
 			"path" : "/2527055923605270645_4300h4.htm",
 			"name" : "2527055923605270645_4300h4.htm",
 			"component" : A527055923605270645_4300H4HTM
 		},
 		{
 			"path" : "/2527055923605270645_4300h5.htm",
 			"name" : "2527055923605270645_4300h5.htm",
 			"component" : A527055923605270645_4300H5HTM
 		},
 		{
 			"path" : "/2527055923605270645_4300h6.htm",
 			"name" : "2527055923605270645_4300h6.htm",
 			"component" : A527055923605270645_4300H6HTM
 		},
 		{
 			"path" : "/2527055923605270645_4300h7.htm",
 			"name" : "2527055923605270645_4300h7.htm",
 			"component" : A527055923605270645_4300H7HTM
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js